import React from 'react';
import { Alert, Box, CircularProgress, Grid, Typography } from '@mui/material';
import { useStorefront } from '../../components/Storefront/StorefrontContext';
import StorefrontProductCard from '../../components/Storefront/StorefrontProductCard';
import { useStorefrontT } from '../../components/Storefront/useStorefrontT';
import { useStorefrontProducts } from './useStorefrontProducts';

/** `/store/:slug/catalog` — alle veröffentlichten Kurse in der gepflegten Reihenfolge. */
const StorefrontCatalog: React.FC = () => {
    const { t } = useStorefrontT();
    const { slug } = useStorefront();
    const { products, error } = useStorefrontProducts(slug);

    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom>{t('catalog.title')}</Typography>
            {error ? <Alert severity="warning">{t('loadError')}</Alert> : null}
            {!products && !error ? <CircularProgress aria-label={t('catalog.title')} /> : null}
            {products && products.length === 0 ? <Typography color="text.secondary">{t('catalog.empty')}</Typography> : null}
            <Grid container spacing={3}>
                {(products ?? []).map((p) => (
                    <Grid key={p.id} size={{ xs: 12, sm: 6, md: 4 }}><StorefrontProductCard product={p} /></Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default StorefrontCatalog;
